import React from 'react';
import useT from '@tools/ui-hooks/useT';

type TProps = {
  amount?: number;
};

const TabAmount: React.FC<TProps> | null = ({ amount }) => {
  const { t } = useT();

  return amount !== undefined ? (
    <>{t('tabAmount', { amount: amount.toLocaleString() })}</>
  ) : null;
};

export default React.memo(TabAmount);
